"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ defaults, palette, typography }) => ({
    loadingStateContainer: {
        display: 'flex',
        width: '100vw',
        height: defaults.content.height,
        justifyContent: 'center',
        alignItems: 'center',
        '&.hoverClass': {
            visibility: 'hide',
        },
        '&:hover': {
            '&.hoverClass': {
                visibility: 'show',
            },
        },
    },
    wrapper: {
        height: '100%',
    },
    zeroStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        color: palette.slateGrey,
        margin: 'auto',
    },
    zeroStateTextHeadline: {
        marginBottom: 10,
        fontWeight: 500,
    },
    zeroStateTextBody: {
        textAlign: 'center',
        maxWidth: '80%',
    },
    strong: {
        fontWeight: typography.fontWeightMedium,
    },
    mergeTxnsBody: {
        fontSize: '18px',
        fontFamily: 'Rubik',
        fontWeight: 400,
        lineHeight: 1.75,
    },
});
exports.styles = styles;
